import Highway from '@dogstudio/highway'

import modular from 'modujs'
import { classesInjection } from './utils/transitions'
import FadeTransition from './modules/FadeTransition'
import Scroller from './modules/Scroller'

import * as modules from './modules'

new Scroller()

const Modular = modular
const app = new Modular({
  modules,
})

class DefaultRenderer extends Highway.Renderer {
  onEnterCompleted() {
    const links = document.querySelectorAll('a[href^="#"]')
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        window.location.hash = ''
        const href = link.getAttribute('href')
        window.lenis.scrollTo(href)
        window.location.hash = href
      })
    })
    app.init(app)
    return this
  }
}

const init = () => {
  classesInjection()
  new Scroller()

  const H = new Highway.Core({
    renderers: {
      default: DefaultRenderer,
    },
    transitions: {
      default: FadeTransition,
    },
  })

  H.on('NAVIGATE_IN', ({ trigger }) => {
    app.destroy()
    window.lenis.start()
    if (trigger !== 'popstate') {
      window.lenis.scrollTo(0, {
        lock: true,
        immediate: true,
      })
    }
  })

  window.H = H
}

document.addEventListener('DOMContentLoaded', init)
